import { MentionNodeAttrs, MentionOptions } from "@tiptap/extension-mention";
import { UserResponse } from "stream-chat";
import { MentionUser } from "util/searchChannelMentionUsers";
import {
  createSuggestionPopupRenderer,
  SuggestionPopup,
} from "./createSuggestionPopupRenderer";

export type MentionItem = {
  id: string;
  label: string;
  image?: string;
  roles: string[];
  user: UserResponse;
};

export type MentionPopup = SuggestionPopup<MentionItem>;

type MentionSuggestionArgs = {
  searchUsers: (query: string) => Promise<MentionUser[]>;
  onSelectUser: (user: UserResponse) => void;
  onPopupChange: (popup: MentionPopup | null) => void;
};

type MentionSuggestion = {
  suggestion: MentionOptions["suggestion"];
  isOpen: () => boolean;
};

const toMentionItem = ({ user, roles }: MentionUser): MentionItem => ({
  id: user.id,
  label: user.name ?? user.id,
  image: typeof user.image === "string" ? user.image : undefined,
  roles,
  user,
});

export const createMentionSuggestion = ({
  searchUsers,
  onSelectUser,
  onPopupChange,
}: MentionSuggestionArgs): MentionSuggestion => {
  const renderer = createSuggestionPopupRenderer<MentionItem, MentionNodeAttrs>(
    {
      onSelect: (item, command) => {
        onSelectUser(item.user);
        command({ id: item.id, label: item.label });
      },
      onPopupChange,
    }
  );

  return {
    isOpen: renderer.isOpen,
    suggestion: {
      items: async ({ query }) => (await searchUsers(query)).map(toMentionItem),
      render: renderer.render,
    },
  };
};
